import React from "react";
import { Row, Col } from "react-bootstrap";
import LineChartWithReferenceLine from "./LineChartWithReferenceLine";

export default function LineCharts(props) {
  return (
    <div>
      <Row>
        <Col xs={12}>
          <h4>∅ Abverkauf pro Markt pro Woche</h4>
        </Col>
      </Row>
      <LineChartWithReferenceLine
        chartTitle="∅ Abverkauf pro Markt pro Woche"
        chartData={props.averageSalesCountPerStorePerWeekChartData}
        referenceLineValue={props.averageSalesCountPerStorePerWeek}
      />

      <Row>
        <Col xs={12}>
          <h4>Gesamtabverkauf kumuliert pro Woche</h4>
        </Col>
      </Row>
      <LineChartWithReferenceLine
        chartTitle="Gesamtabverkauf kumuliert pro Woche"
        chartData={props.absoluteSalesCountPerStorePerWeekChartData}
        referenceLineValue={props.absoluteSalesCountPerStorePerWeek}
      />

      <Row>
        <Col xs={12}>
          <h4>∅ Umsatz pro Markt pro Woche</h4>
        </Col>
      </Row>
      <LineChartWithReferenceLine
        chartTitle="∅ Umsatz pro Markt pro Woche"
        chartData={props.averageSalesRevenuePerStorePerWeekChartData}
        referenceLineValue={props.averageSalesRevenuePerStorePerWeek}
      />
    </div>
  );
}
